module.exports = __webpack_public_path__ + "img/m5.d4fe0bd7.jpg";